export interface VideoMetadata {
  duration?: number;
  width?: number;
  height?: number;
  fps?: number;
  codec?: string;
  [key: string]: unknown;
}

export type VideoGenerationMode = 'DEFAULT' | 'CONTINUE' | 'CUT' | 'FIRST_LAST_FRAME' | 'CHARACTER_REF' | 'txt2video' | 'omni' | 'img2video' | 'first_last' | 'img_ref';

export type ImageGenerationMode = 'TXT2IMG' | 'IMG2IMG' | 'UPSCALE' | 'STYLE';

export type ConsistencyMode = 'CHARACTER' | 'PRODUCT' | 'SCENE' | 'ALL';

export const ConsistencyModeLabels: Record<ConsistencyMode, string> = {
  'CHARACTER': '人物一致性',
  'PRODUCT': '产品一致性',
  'SCENE': '场景一致性',
  'ALL': '全部一致性'
};

export enum PanoramaQuality {
  STANDARD = 'standard',
  HD = 'hd',
  ULTRA = 'ultra',
}

export const PanoramaQualityLabels: Record<PanoramaQuality, string> = {
  [PanoramaQuality.STANDARD]: '1K',
  [PanoramaQuality.HD]: '2K',
  [PanoramaQuality.ULTRA]: '4K',
};

export const PanoramaQualityDimensions: Record<PanoramaQuality, { width: number; height: number }> = {
  [PanoramaQuality.STANDARD]: { width: 1024, height: 512 },
  [PanoramaQuality.HD]: { width: 2048, height: 1024 },
  [PanoramaQuality.ULTRA]: { width: 3840, height: 1920 },
};

export interface SmartSequenceItem {
    id: string;
    src: string;
    transition: {
        duration: number;
        prompt: string;
    };
}
